import { render, staticRenderFns } from "./CreateRelationNote.vue?vue&type=template&id=0f4a0e98"
import script from "./CreateRelationNote.vue?vue&type=script&lang=js"
export * from "./CreateRelationNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports